import { config } from 'config/firebase.staging'
import { initializeApp } from 'firebase/app'

export const firebase = initializeApp(config)
